/*
 * <hlth-buy-box>: behaviour for snippets/hlth-buy-box.liquid (built 16 Oct 2026, buy box option B).
 *
 * State: Subscribe or One-time, the delivery plan, and a quantity per variant. The page opens in the
 * state Liquid drew, so nothing moves while this loads; the script keeps the prices, saving badge,
 * total, button and minimum in step, and adds to the cart.
 *
 * Minimum: with Subscribe chosen the box never drops below the block's minimum (Meal Replacement: 2).
 * Minus buttons stop there, and choosing Subscribe while short tops up the first chosen row.
 *
 * Adding: one POST to /cart/add with every chosen line (selling_plan on each when subscribing), asking
 * for the cart drawer and cart bubble sections; the drawer redraws and opens. This is the request the
 * flavour selector used to send, unchanged in shape: hlth-free-gift.js wraps fetch to add the ebook to
 * it, and the free shaker reads the selling plans off the cart lines. No cartUpdate is published, as
 * before (the free shaker's take-back listens to it).
 *
 * The sticky bar (sections/hlth-sticky-atc.liquid) listens for 'hlth:buybox-change'
 * (detail: { summary, total, totalText, addText }) and calls addToCart(itsButton).
 */
(function () {
  if (customElements.get('hlth-buy-box')) return;

  function formatMoney(cents, format) {
    var value = cents / 100;
    var whole = cents % 100 === 0;
    function delimit(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    var fmt = format || '${{amount}}';
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var out;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': out = delimit(value, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = delimit(value, whole ? 0 : 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = delimit(value, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = delimit(value, whole ? 0 : 2, "'", '.'); break;
      default: out = delimit(value, whole ? 0 : 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out).replace(/<[^>]*>/g, '');
  }

  class HlthBuyBox extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      var cfgEl = this.querySelector('[data-hbb-config]');
      if (!cfgEl) return;
      try {
        this.cfg = JSON.parse(cfgEl.textContent);
      } catch (e) {
        return;
      }
      this._ready = true;
      var cfg = this.cfg;
      var byId = {};
      cfg.variants.forEach(function (v) { byId[v.id] = v; });

      this.rows = Array.prototype.map.call(this.querySelectorAll('[data-hbb-row]'), function (el) {
        var qtyEl = el.querySelector('[data-hbb-qty]');
        return {
          el: el,
          variant: byId[el.getAttribute('data-variant-id')],
          qtyEl: qtyEl,
          dec: el.querySelector('[data-hbb-dec]'),
          inc: el.querySelector('[data-hbb-inc]'),
          qty: qtyEl ? parseInt(qtyEl.textContent, 10) || 0 : 0,
        };
      });
      this.purchaseInputs = Array.prototype.slice.call(this.querySelectorAll('[data-hbb-purchase]'));
      this.planInputs = Array.prototype.slice.call(this.querySelectorAll('[data-hbb-plan]'));
      this.addBtn = this.querySelector('[data-hbb-add]');
      this.addLabel = this.querySelector('[data-hbb-add-label]');
      this.errorEl = this.querySelector('[data-hbb-error]');
      this.hint = this.querySelector('[data-hbb-hint]');

      var self = this;
      this.purchaseInputs.forEach(function (input) {
        input.addEventListener('change', function () { self.onPurchase(); });
      });
      this.planInputs.forEach(function (input) {
        input.addEventListener('change', function () { self.render(); });
      });
      this.rows.forEach(function (row) {
        if (row.dec) row.dec.addEventListener('click', function () { self.step(row, -1); });
        if (row.inc) row.inc.addEventListener('click', function () { self.step(row, 1); });
      });
      var shaker = this.querySelector('[data-hbb-shaker]');
      if (shaker) {
        shaker.addEventListener('click', function () {
          if (self.isSub()) return;
          var subInput = self.purchaseInputs.filter(function (i) { return i.value === 'sub'; })[0];
          if (subInput) {
            subInput.checked = true;
            self.onPurchase();
          }
        });
      }
      var form = this.querySelector('[data-hbb-form]');
      this.form = form;
      this.itemsEl = this.querySelector('[data-hbb-items]');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          self.addToCart(self.addBtn);
        });
      }
      this.render();
    }

    isSub() {
      if (!this.purchaseInputs.length) return !!this.cfg.sub;
      var checked = this.purchaseInputs.filter(function (i) { return i.checked; })[0];
      return !!checked && checked.value === 'sub';
    }

    planId() {
      var checked = this.planInputs.filter(function (i) { return i.checked; })[0];
      if (checked) return checked.value;
      var plan = this.cfg.plans[this.cfg.planIndex] || this.cfg.plans[0];
      return plan ? String(plan.id) : null;
    }

    units() {
      return this.rows.reduce(function (sum, row) { return sum + row.qty; }, 0);
    }

    minUnits() {
      return this.isSub() ? Math.max(1, this.cfg.min || 1) : 1;
    }

    unitPrice(variant, sub, planId) {
      if (sub && planId && variant.plans && variant.plans[planId] != null) return variant.plans[planId];
      return variant.price;
    }

    step(row, delta) {
      var next = row.qty + delta;
      if (next < 0) return;
      if (delta < 0 && this.units() - 1 < this.minUnits()) {
        this.flashHint();
        return;
      }
      if (next > 99) return;
      row.qty = next;
      this.render();
    }

    popBadge() {
      // A small bounce when the saving changes
      var badge = this.querySelector('[data-hbb-badge]');
      if (!badge || badge.hidden) return;
      badge.classList.remove('is-pop');
      void badge.offsetWidth;
      badge.classList.add('is-pop');
      clearTimeout(this._badgeTimer);
      this._badgeTimer = setTimeout(function () { badge.classList.remove('is-pop'); }, 600);
    }

    onPurchase() {
      if (this.isSub()) {
        var short = this.minUnits() - this.units();
        if (short > 0) {
          var target = this.rows.filter(function (r) { return r.qty > 0 && r.variant && r.variant.available; })[0] ||
            this.rows.filter(function (r) { return r.variant && r.variant.available; })[0];
          if (target) {
            target.qty += short;
            this.flashHint();
          }
        }
      }
      this.render();
    }

    flashHint() {
      if (!this.hint) return;
      var hint = this.hint;
      hint.classList.add('is-flash');
      clearTimeout(this._hintTimer);
      this._hintTimer = setTimeout(function () { hint.classList.remove('is-flash'); }, 1600);
    }

    supplyText(units) {
      var t = this.cfg.text;
      var days = units * (this.cfg.daysPerUnit || 30);
      if (days > 0 && days % 30 === 0) {
        var months = days / 30;
        var word = (t.words && t.words[months - 1] ? String(t.words[months - 1]).trim() : '') || String(months);
        return t.supplyMonths.replace('[n]', word);
      }
      return t.supplyDays.replace('[n]', days);
    }

    money(cents) {
      return formatMoney(cents, this.cfg.moneyFormat);
    }

    state() {
      var sub = this.isSub();
      var planId = this.planId();
      var self = this;
      var total = 0;
      var was = 0;
      this.rows.forEach(function (row) {
        if (!row.variant || !row.qty) return;
        total += row.qty * self.unitPrice(row.variant, sub, planId);
        was += row.qty * row.variant.price;
      });
      var units = this.units();
      var t = this.cfg.text;
      var unitWord = units === 1 ? t.unitOne : t.unitMany;
      return {
        sub: sub,
        planId: planId,
        units: units,
        total: total,
        was: was,
        totalText: this.money(total),
        summary: units + ' ' + unitWord + ' · ' + (sub ? t.subscribe : t.onetime),
        addText: t.add,
      };
    }

    render() {
      var cfg = this.cfg;
      var t = cfg.text;
      var st = this.state();
      var self = this;
      var min = this.minUnits();

      this.classList.toggle('is-sub', st.sub);
      Array.prototype.forEach.call(this.querySelectorAll('[data-hbb-plans], [data-hbb-sub-only]'), function (el) {
        el.hidden = !st.sub;
      });

      // Switch prices follow the chosen plan (Berberine's 3-monthly plan saves more than the others)
      var ref = this.rows.filter(function (r) { return r.variant && r.variant.available; })[0] || this.rows[0];
      if (ref && ref.variant) {
        var subUnit = this.unitPrice(ref.variant, true, st.planId);
        var oneUnit = ref.variant.price;
        var pct = oneUnit > 0 ? Math.round(((oneUnit - subUnit) * 100) / oneUnit) : 0;
        var subPrice = this.querySelector('[data-hbb-sub-price]');
        if (subPrice) subPrice.textContent = this.money(subUnit);
        var badge = this.querySelector('[data-hbb-badge]');
        if (badge) {
          var badgeText = t.badge.replace('[percent]', pct);
          var changed = this._badgeText !== undefined && this._badgeText !== badgeText;
          this._badgeText = badgeText;
          badge.textContent = badgeText;
          badge.hidden = pct <= 0;
          if (changed) this.popBadge();
        }
      }

      this.rows.forEach(function (row) {
        if (row.qtyEl) row.qtyEl.textContent = String(row.qty);
        if (row.dec) row.dec.disabled = row.qty <= 0 || st.units - 1 < min;
        if (row.inc) row.inc.disabled = row.qty >= 99;
      });

      var what = this.querySelector('[data-hbb-what]');
      if (what) what.textContent = st.units + ' ' + (st.units === 1 ? t.unitOne : t.unitMany) + ' · ' + this.supplyText(st.units);
      var wasEl = this.querySelector('[data-hbb-was]');
      if (wasEl) {
        wasEl.textContent = this.money(st.was);
        wasEl.hidden = !(st.sub && st.was > st.total);
      }
      var totalEl = this.querySelector('[data-hbb-total]');
      if (totalEl) totalEl.textContent = st.totalText;

      if (this.addBtn && this.addLabel) {
        var anyAvailable = this.rows.some(function (r) { return r.variant && r.variant.available; });
        if (!anyAvailable) {
          this.addLabel.textContent = t.soldOut;
          this.addBtn.disabled = true;
        } else {
          this.addLabel.textContent = '';
          this.addLabel.appendChild(document.createTextNode(t.add + ' '));
          var sep = document.createElement('span');
          sep.className = 'hbb-add__sep';
          sep.setAttribute('aria-hidden', 'true');
          sep.textContent = '·';
          this.addLabel.appendChild(sep);
          this.addLabel.appendChild(document.createTextNode(' ' + st.totalText));
          this.addBtn.disabled = st.units < 1;
        }
      }
      if (this.errorEl) this.errorEl.hidden = true;

      this.dispatchEvent(new CustomEvent('hlth:buybox-change', { bubbles: true, detail: st }));
    }

    items() {
      var st = this.state();
      var items = [];
      this.rows.forEach(function (row) {
        if (!row.variant || !row.variant.available || row.qty <= 0) return;
        var item = { id: row.variant.id, quantity: row.qty };
        if (st.sub && st.planId) item.selling_plan = Number(st.planId);
        items.push(item);
      });
      return items;
    }

    syncFormItems() {
      if (!this.itemsEl) return;
      var html = '';
      this.items().forEach(function (item, i) {
        html += '<input type="hidden" name="items[' + i + '][id]" value="' + item.id + '">' +
          '<input type="hidden" name="items[' + i + '][quantity]" value="' + item.quantity + '">' +
          (item.selling_plan ? '<input type="hidden" name="items[' + i + '][selling_plan]" value="' + item.selling_plan + '">' : '');
      });
      this.itemsEl.innerHTML = html;
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message;
      this.errorEl.hidden = false;
    }

    addToCart(trigger) {
      if (this._busy) return Promise.resolve(false);
      var self = this;
      var items = this.items();
      var st = this.state();
      if (!items.length || (st.sub && st.units < this.minUnits())) {
        this.flashHint();
        return Promise.resolve(false);
      }
      this._busy = true;
      var buttons = [this.addBtn];
      if (trigger && trigger !== this.addBtn) buttons.push(trigger);
      buttons.forEach(function (b) {
        if (!b) return;
        b.classList.add('is-loading');
        b.setAttribute('aria-busy', 'true');
      });

      var drawer = document.querySelector('cart-drawer');
      var bubble = document.getElementById('cart-icon-bubble');
      var sections = [];
      if (drawer) sections.push(drawer.getAttribute('data-section-id') || 'cart-drawer');
      if (bubble) sections.push('cart-icon-bubble');
      var body = { items: items };
      if (sections.length) {
        body.sections = sections.join(',');
        body.sections_url = window.location.pathname;
      }

      return fetch(this.cfg.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify(body),
      })
        .then(function (r) {
          return r.text().then(function (text) {
            var data = null;
            try {
              data = JSON.parse(text);
            } catch (e) {
              data = null;
            }
            if (!data && (r.status === 429 || r.status === 403)) {
              // Shopify's bot check answered instead of the cart, so nothing was added. Post the form
              // as a normal page load (the browser can pass the check); Shopify adds the same lines and
              // shows the cart page.
              var err = new Error('challenge');
              err.challenge = true;
              throw err;
            }
            if (!r.ok || !data || data.status) throw data || {};
            return data;
          });
        })
        .then(function (data) {
          if (data.sections) {
            Object.keys(data.sections).forEach(function (key) {
              var html = data.sections[key];
              if (!html) return;
              var parsed = new DOMParser().parseFromString(html, 'text/html');
              if (key === 'cart-icon-bubble') {
                var el = document.getElementById('cart-icon-bubble');
                var src = parsed.querySelector('.shopify-section');
                if (el && src) el.innerHTML = src.innerHTML;
              } else if (drawer) {
                var srcDrawer = parsed.querySelector('cart-drawer');
                if (srcDrawer) drawer.innerHTML = srcDrawer.innerHTML;
              }
            });
          }
          if (drawer && typeof drawer.open === 'function') {
            drawer.classList.remove('is-empty');
            drawer.open(trigger || self.addBtn);
          } else {
            window.location.href = self.cfg.cartUrl;
          }
          return true;
        })
        .catch(function (err) {
          if (err && err.challenge && self.form) {
            self.syncFormItems();
            self.form.submit();
            return false;
          }
          var message = (err && typeof err.description === 'string' && err.description) ||
            (window.cartStrings && window.cartStrings.error) || '';
          if (message) self.showError(message);
          if (trigger && trigger !== self.addBtn) self.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return false;
        })
        .finally(function () {
          self._busy = false;
          buttons.forEach(function (b) {
            if (!b) return;
            b.classList.remove('is-loading');
            b.removeAttribute('aria-busy');
          });
        });
    }
  }

  customElements.define('hlth-buy-box', HlthBuyBox);
})();
